module.exports = __webpack_public_path__ + "static/img/cont49 (3).a16ddd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont49 (3).jpg
// module id = Qm1A
// module chunks = 0